import React, { FC, ReactNode } from 'react';

import styled from 'styled-components';

import Link from 'components/Link';

const StyledLink = styled(Link)<{ $iconUrl: string }>`
  position: relative;
  margin-right: 29px;

  &&::after {
    content: ${(props) => `url(${props.$iconUrl})`};
    display: inline-block;
    width: 1.5rem;
    position: absolute;
    right: -29px;
    top: 50%;
    transform: translateY(-40%);
  }
`;

interface LinkWithIconProps {
  iconUrl: string;
  clickHandler: () => void;
  children: ReactNode[] | ReactNode;
  dataTestId: string;
}

export const LinkWithIcon: FC<LinkWithIconProps> = ({ iconUrl, clickHandler, children, dataTestId }) => {
  return (
    <StyledLink
      to={undefined}
      onClick={clickHandler}
      className='buttonLink'
      $iconUrl={iconUrl}
      data-testId={dataTestId}
    >
      {children}
    </StyledLink>
  );
};
